import Vue from 'vue';
import utilities from '@/mixins/util.mixin';

Vue.mixin(utilities);
